import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { Button, toast } from '@wit-support/ui';
import { RailCard } from '@wit-support/ui-domain';
import { Copy, Image } from 'lucide-react';
import { listUserPortraits } from '../api.js';
/**
 * Right-rail «Портреты» section: the soulmate-portrait links for the resolved
 * user. We show only the portrait NAME + a copy-link button — the URL itself is
 * never rendered. The whole section is hidden when portraits aren't configured
 * or the user has none, mirroring SubscriptionPanel's no-clutter loading rule.
 */
export function PortraitsPanel({ conversationId, canRead, }) {
    const q = useQuery({
        queryKey: ['portraits', conversationId],
        queryFn: () => listUserPortraits(conversationId),
        staleTime: 60_000,
        // Viewers lack `portraits.read` — don't fire the query (would 403 on every
        // chat open, swallowed by the fail-soft render below).
        enabled: canRead,
    });
    async function copyUrl(url) {
        try {
            await navigator.clipboard.writeText(url);
            toast.success('Ссылка скопирована');
        }
        catch {
            toast.error('Не удалось скопировать');
        }
    }
    if (q.isLoading || q.isError || !q.data || !q.data.configured || q.data.portraits.length === 0) {
        return null;
    }
    return (_jsx(RailCard, { icon: Image, title: "\u041F\u043E\u0440\u0442\u0440\u0435\u0442\u044B", children: q.data.portraits.map((p) => (_jsxs("div", { className: "flex items-center justify-between gap-2 rounded-md border border-[var(--color-border-default)] bg-[var(--color-surface-default)] px-2.5 py-2", children: [_jsxs("div", { className: "flex min-w-0 flex-col", children: [_jsx("span", { className: "min-w-0 truncate text-[var(--color-text-primary)]", title: p.name, children: p.name }), _jsx("span", { className: "min-w-0 truncate font-mono text-xs text-[var(--color-text-muted)]", title: p.key, children: p.key })] }), _jsx(Button, { variant: "ghost", size: "sm", className: "shrink-0", onClick: () => void copyUrl(p.url), "aria-label": "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443", title: "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443", children: _jsx(Copy, { className: "h-3.5 w-3.5", "aria-hidden": "true" }) })] }, p.key))) }));
}
//# sourceMappingURL=portraits-panel.js.map